import React, { Component } from 'react';
import ReactEcharts from "echarts-for-react"
import ComfortableHousingRequestHandler from '../../../db/ComfortableHousingRequestHandler';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import { observer } from "mobx-react";

const styles = {
  formControl: {
    margin: '10px',
    minWidth: 320,
  },
  selectEmpty: {
    marginTop: '10px',
  },
};


let data = {};

class Echart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      option: {}, // 图标参数
      selectionValue: '',
      selections: [],
      chartHeight: '200vh',
    };
    this.setData = this.setData.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  async componentDidMount() {
    const rst = await ComfortableHousingRequestHandler.getStatistic({});
    data = rst.data;

    const selections = [];
    const keys = Object.keys(data);
    for (let index = 0; index < keys.length; index++) {
      const sid = keys[index];
      const element = data[sid];
      selections.push({
        selectionValue: (1 + index) * 10,
        label: element.label,
        sid
      });
    }
    this.setState({ selections: selections })
  }

  setData(sid) {
    // const propertyNameList = rst.data.property_name;
    const categoryList = data[sid].list;
    const categorySortedList = categoryList.sort((a, b) => (a.cnt - b.cnt));
    let chartHeight = categoryList.length * 4;
    chartHeight = chartHeight > 80 ? chartHeight : 80;
    this.setState({ chartHeight: `${chartHeight}vh` });
    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          // Use axis to trigger tooltip
          type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
        }
      },
      legend: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: { type: 'value' },
      yAxis: { type: 'category', data: [] },
      series: [
        {
          name: 'Direct',
          type: 'bar',
          stack: 'total',
          label: {
            show: true
          },
          emphasis: { focus: 'series' },
          data: []
        },
      ]
    };

    // option.xAxis.type = 'category';
    option.yAxis.data = [];
    option.series = [
      {
        name: '分类',
        type: 'bar',
        stack: 'total',
        label: {
          show: true
        },
        emphasis: {
          focus: 'series'
        },
        data: [],
      },
    ];

    for (let index = 0; index < categorySortedList.length; index++) {
      const element = categorySortedList[index];
      const category = element.category;
      const cnt = element.cnt;
      option.yAxis.data.push(category || '未定');
      option.series[0].data.push(cnt);
    }

    this.setState({ option: option });
  }


  handleChange(event) {
    const value = event.target.value; // 10, 20, 30
    let sid = '';
    let label = '';
    for (let index = 0; index < this.state.selections.length; index++) {
      const selection = this.state.selections[index];
      if (selection.selectionValue === value) {
        sid = selection.sid;
        label = selection.label;
        break;
      }
    }

    console.log(`----- handleChange: sid: ${sid}, label: ${label}. `);

    this.setState({ selectionValue: value });
    this.setData(sid);
  };


  render() {
    const { classes } = this.props;

    console.log(`----- render-selectionValue: `, this.state.selectionValue);

    if (this.state.selections.length === 0) {
      return (<>加载中</>);
    }
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <FormControl variant="filled" className={classes.formControl}>
            <InputLabel id="demo-simple-select-label">
              请选择
            </InputLabel>
            <Select
              labelId="simple-select-label"
              id="simple-select"
              value={this.state.selectionValue}
              defaultValue='请选择'
              onChange={e => this.handleChange(e)}
            >
              {
                this.state.selections.map(
                  (selection, index) =>
                    <MenuItem
                      key={index}
                      value={selection.selectionValue}
                    >
                      {selection.label}
                    </MenuItem>
                )
              }
            </Select>
          </FormControl>
        </Grid>
        {
          this.state.selectionValue && (
            <Grid item xs={12}>
              <ReactEcharts
                option={this.state.option}
                style={{ width: '100%', height: this.state.chartHeight, marginTop: '0', }}
              />
            </Grid>
          )
        }
      </Grid>
    );
  }
}

const EchartObserver = observer(Echart);


export default withStyles(styles)(EchartObserver);
